import { createSetting } from '@shopex/finder'
import { IS_DISTI_ADMIN } from '@/utils'

export const StatusOption = [
  { label: '全部', value: 'all' },
  { label: '草稿', value: 'draft' },
  { label: '未开始', value: 'not_started' },
  { label: '进行中', value: 'processing' },
  { label: '已过期', value: 'expired' }
]

export const StatusLabelMap = {
  draft: '草稿',
  not_started: '未开始',
  processing: '进行中',
  expired: '已过期',
  not_created: '未创建',
  unpublished: '未发布',
  published: '已发布',
  offline: '已下架',
  off_shelf: '已下架',
  pending: '待开始',
  pending_start: '待开始',
  running: '进行中',
  ended: '已结束'
}

export const OwnerTypeMap = {
  platform: '平台',
  dealer: '经销商'
}

export const PeriodOptions = [
  { label: '3期', value: 3 },
  { label: '6期', value: 6 },
  { label: '12期', value: 12 },
  { label: '24期', value: 24 }
]

export const ActionLabels = {
  publish: '上架',
  unpublish: '下架',
  edit: '编辑',
  viewDealer: '查看经销商',
  viewGoods: '查看商品',
  viewSubsidy: '查看商贴流水'
}

function formatTimestamp (vm, timestamp) {
  if (!timestamp && timestamp !== 0) return ''
  const ts = Number(timestamp)
  if (Number.isNaN(ts)) return ''
  // datetime 过滤器按秒级时间戳处理（内部会 * 1000）
  const seconds = ts > 1e12 ? Math.floor(ts / 1000) : ts
  return vm.$options.filters.datetime.call(vm, seconds, 'yyyy-MM-dd hh:mm:ss')
}

export const tableSetting = (vm) => createSetting({
  columns: [
    {
      name: 'ID',
      key: 'activity_id',
      width: 80
    },
    {
      name: '活动名称',
      key: 'activity_name',
      minWidth: 220
    },
    {
      name: '活动参与期数',
      key: 'installment_terms',
      minWidth: 140,
      render: (h, { row }) => (row.installment_terms || []).join(', ')
    },
    {
      name: '活动归属',
      key: 'owner_type',
      width: 100,
      formatter: (v) => OwnerTypeMap[v] || v
    },
    {
      name: '状态',
      key: 'display_status',
      width: 100,
      formatter: (v) => StatusLabelMap[v] || v
    },
    {
      name: '有效期',
      key: 'valid_time',
      minWidth: 320,
      render: (h, { row }) => {
        const start = formatTimestamp(vm, row.start_time)
        const end = formatTimestamp(vm, row.end_time)
        return `${start} ~ ${end}`
      }
    }
  ],
  actions: [
    {
      name: ActionLabels.publish,
      type: 'button',
      buttonType: 'text',
      visible: (row) => IS_DISTI_ADMIN()
        && ['unpublished', 'not_created'].includes(row.status)
        && !row.has_pending_create
        && row.display_status !== 'expired',
      action: {
        handler: (rows) => vm.handleAction('publish', rows[0])
      }
    },
    {
      name: ActionLabels.edit,
      type: 'button',
      buttonType: 'text',
      visible: (row) => IS_DISTI_ADMIN() && row.display_status !== 'expired',
      action: {
        handler: (rows) => vm.handleAction('edit', rows[0])
      }
    },
    {
      name: ActionLabels.viewDealer,
      type: 'button',
      buttonType: 'text',
      visible: () => IS_DISTI_ADMIN(),
      action: {
        handler: (rows) => vm.handleAction('viewDealer', rows[0])
      }
    },
    {
      name: ActionLabels.viewGoods,
      type: 'button',
      buttonType: 'text',
      visible: () => IS_DISTI_ADMIN(),
      action: {
        handler: (rows) => vm.handleAction('viewGoods', rows[0])
      }
    },
    {
      name: ActionLabels.unpublish,
      type: 'button',
      buttonType: 'text',
      visible: (row) => IS_DISTI_ADMIN() && row.status === 'published' && row.display_status !== 'expired',
      action: {
        handler: (rows) => vm.handleAction('unpublish', rows[0])
      }
    },
    {
      name: ActionLabels.viewSubsidy,
      type: 'button',
      buttonType: 'text',
      visible: (row) => row.status === 'published' || row.status === 'offline',
      action: {
        handler: (rows) => vm.handleAction('viewSubsidy', rows[0])
      }
    }
  ]
})

export const draftTableSetting = (vm) => createSetting({
  columns: [
    { name: 'ID', key: 'draft_id', width: 100 },
    { name: '活动名称', key: 'activity_name', minWidth: 220 },
    {
      name: '活动参与期数',
      key: 'installment_terms',
      minWidth: 140,
      render: (h, { row }) => (row.installment_terms || []).join(', ')
    },
    {
      name: '活动归属',
      key: 'owner_type',
      width: 100,
      formatter: (v) => OwnerTypeMap[v] || v
    },
    {
      name: '状态',
      key: 'display_status',
      width: 100,
      formatter: () => '草稿'
    },
    {
      name: '有效期',
      key: 'valid_time',
      minWidth: 320,
      render: (h, { row }) => {
        const start = row.start_time ? formatTimestamp(vm, row.start_time) : ''
        const end = row.end_time ? formatTimestamp(vm, row.end_time) : ''
        if (!start && !end) return ''
        return `${start} ~ ${end}`
      }
    }
  ],
  actions: [
    {
      name: '编辑',
      type: 'button',
      buttonType: 'text',
      visible: () => IS_DISTI_ADMIN(),
      action: { handler: (rows) => vm.handleAction('draftEdit', rows[0]) }
    },
    {
      name: '创建活动',
      type: 'button',
      buttonType: 'text',
      visible: () => IS_DISTI_ADMIN(),
      action: { handler: (rows) => vm.handleAction('draftCreate', rows[0]) }
    },
    {
      name: '删除',
      type: 'button',
      buttonType: 'text',
      visible: () => IS_DISTI_ADMIN(),
      action: { handler: (rows) => vm.handleAction('draftDelete', rows[0]) }
    }
  ]
})
